import { flushSync } from "react-dom";

type DraftEditor = {
	getContainer: () => HTMLElement | null;
	dispatch: (event: "blur") => void;
};

/** TinyMCE's blur callback commits text to the canvas; ordinary keystrokes stay editor-local. */
export function commitCampaignEditors() {
	const manager = (window as Window & { tinymce?: { get: () => DraftEditor[] } }).tinymce;
	const editors =
		manager?.get().filter((editor) => editor.getContainer()?.closest("[data-campaign-builder]")) ??
		[];

	// Commit before reading the canvas, including validation derived in the React render. Only
	// this builder's editors participate; hidden editors elsewhere on the page own other drafts.
	if (editors.length) {
		// eslint-disable-next-line @eslint-react/dom/no-flush-sync -- One TinyMCE hand-off must settle validation before settings acquires ownership.
		flushSync(() => editors.forEach((editor) => editor.dispatch("blur")));
	}
}
